import { H } from "@jfrk/react-heading-levels";
import { apartmentContext } from "@whitespace/gatsby-plugin-smorgasbord-fastapi";
import {
  ErrorMessage,
  Loading,
} from "@whitespace/gatsby-theme-smorgasbord/src/components";
import clsx from "clsx";
import { parseISO } from "date-fns";
import PropTypes from "prop-types";
import React, { useState, useContext } from "react";
// import { useTranslation } from "react-i18next";

import AptusContext from "../contexts/aptusContext";

import * as defaultStyles from "./BookModal.module.css";
import ConfirmationScreen from "./ConfirmationScreen";
import ServerResponseError from "./ServerResponseError";
import Timeslot from "./Timeslot";

BookModal.propTypes = {
  styles: PropTypes.objectOf(PropTypes.string),
  className: PropTypes.string,
  day: PropTypes.object,
};

function capitalize(locale, str) {
  return str.charAt(0).toLocaleUpperCase(locale) + str.slice(1);
}

export default function BookModal({
  styles = defaultStyles,
  className,
  day,
  ...restProps
}) {
  // const { i18n } = useTranslation();
  // const locale = i18n.language;
  // XXX: Hard-coding it since above doesn't work for some reason
  const locale = "sv";
  const { bookedPass, setBookedPass, groups } = useContext(AptusContext);
  const [error, setError] = useState();
  const [loading, setLoading] = useState();

  const { selectedApartment } = useContext(apartmentContext);
  const groupId = day.groupId;
  const groupName = groups?.find((group) => group.id == groupId).name;
  const timestamp = parseISO(day.date);
  const date = capitalize(
    locale,
    timestamp.toLocaleDateString(locale, {
      weekday: "long",
      month: "long",
      day: "numeric",
    }),
  );

  const handleCreateBooking = async (pass) => {
    setError(null);
    setLoading(true);
    try {
      let response = await fetch(
        `/api/aptus-booking/apartments/${selectedApartment.id}/bookings`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            startTime: `${day.date}T${pass.StartTime}`,
            length: pass.LengthMinutes,
            groupId,
          }),
          cache: "no-cache",
        },
      );
      const result = await response.json();
      if (!response.ok) {
        throw new ServerResponseError(result);
      }
      setBookedPass(pass);
    } catch (e) {
      setError(e);
    }
    setLoading(false);
  };

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorMessage error={error.message} />;
  }

  return (
    <div className={clsx(styles.component, className)} {...restProps}>
      <H className={clsx(styles.headingDate, className)}>{date}</H>
      <H className={clsx(styles.headingGroupName, className)}>{groupName}</H>

      {bookedPass ? (
        <ConfirmationScreen day={day} pass={bookedPass} />
      ) : (
        <ul className={clsx(styles.list, className)}>
          {day.passes.map((pass, index) => (
            <li key={index} className={clsx(styles.listItem, className)}>
              <Timeslot
                pass={pass}
                handleCreateBooking={() => handleCreateBooking(pass)}
              />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
